import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import AuthorityGuard from "./AuthorityGuard";
import AppRoute from "./AppRoute";
import PageContainer from "@/components/template/PageContainer";
import { protectedRoutes, publicRoutes } from "@/configs/routes.config";
import appConfig from "@/configs/app.config";
import { Routes, Route, Navigate } from "react-router-dom";
import type { LayoutType } from "@/@types/theme";

interface ViewsProps {
  pageContainerType?: "default" | "gutterless" | "contained";
  layout?: LayoutType;
}

type AllRoutesProps = ViewsProps;

const { authenticatedEntryPath } = appConfig;

const AllRoutes = (props: AllRoutesProps) => {
  return (
    <Routes>
      <Route path="/" element={<ProtectedRoute />}>
        <Route path="/" element={<Navigate replace to={authenticatedEntryPath} />} />
        {protectedRoutes.map((route, index) => (
          <Route
            key={route.key + index}
            path={route.path}
            element={
              <AuthorityGuard userAuthority={[]} authority={route.authority}>
                <PageContainer {...props} {...route.meta}>
                  <AppRoute routeKey={route.key} component={route.component} {...route.meta} />
                </PageContainer>
              </AuthorityGuard>
            }
          />
        ))}
        <Route path="*" element={<Navigate replace to="/" />} />
      </Route>
      <Route path="/" element={<PublicRoute />}>
        {publicRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<AppRoute routeKey={route.key} component={route.component} {...route.meta} />}
          />
        ))}
      </Route>
    </Routes>
  );
};

export default AllRoutes;
